import React from "react";
import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { posts } from "@/lib/resources";

export const ResourcesPreview = () => (
  <section className="bg-[#F8F9FA] border-y border-[#EAEAEA]" data-testid="resources-preview">
    <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28">
      <Reveal>
        <div className="max-w-2xl">
          <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A]">
            Resources
          </div>
          <h2 className="mt-4 font-display text-[36px] md:text-[52px] leading-[1.05] font-black tracking-tight text-[#0F1115]">
            Real reads for <span className="hl-yellow">First-Time Founders</span>.
          </h2>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.slice(0, 3).map((p, i) => (
          <Reveal key={p.slug} delay={i * 80}>
            <Link
              to={`/resources/${p.slug}`}
              className="group block h-full bg-white border border-[#EAEAEA] rounded-2xl overflow-hidden hover:border-[#0F1115] transition-colors"
              data-testid={`resource-card-${p.slug}`}
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={p.img}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <div className="inline-block text-[10px] uppercase tracking-[0.22em] font-bold text-[#0F1115] bg-[#FDD805] px-2.5 py-1 rounded-full">
                  {p.tag}
                </div>
                <h3 className="mt-4 font-display text-[19px] font-bold text-[#0F1115] leading-[1.25]">
                  {p.title}
                </h3>
                <div className="mt-4 text-[12px] text-[#4A4A4A]">{p.read} read</div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ResourcesPreview;
